import {H3} from '../headings';
import {styled} from 'styled-components';

const HiddenNavH3 = styled(H3).attrs(() => ({as: 'p'}))`
    color: ${(props): string => props.theme.colors.ballena};
    line-height: 24px;
    margin: 16px;
`;

export {HiddenNavH3};
